import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useLanguage } from '../contexts/LanguageContext';

export const Impressum = () => {
  const { t } = useLanguage();
  const L = (key) => t(`legal.impressum.${key}`);
  return (
    <div className="min-h-screen flex flex-col bg-ngbc-beige">
      <Header />
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-12 mt-20">
        <h1 className="text-4xl font-bold text-ngbc-dark mb-8">{L('title')}</h1>
        
        <div className="bg-ngbc-beige rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section1')}</h2>
            <p className="text-ngbc-dark-text">
              IS@M- International Students at Mediapark e.V.<br />
              Im Mediapark 5c<br />
              50670 Köln
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">Vertreten durch</h2>
            <p className="text-ngbc-dark-text">
              Paul Kleiber, Paul Schneider, Kilian Rao
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section3')}</h2>
            <p className="text-ngbc-dark-text">
              Telefon: +49 173 6090971<br />
              E-Mail: info@nextgenbusinesscup.com
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section4')}</h2>
            <p className="text-ngbc-dark-text">
              Eintragung im Handelsregister<br />
              Registergericht: [Amtsgericht]<br />
              Registernummer: [HRB-Nummer]
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section5')}</h2>
            <p className="text-ngbc-dark-text">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              [USt-IdNr.]
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section6')}</h2>
            <p className="text-ngbc-dark-text">
              IS@M- International Students at Mediapark e.V.<br />
              Im Mediapark 5c<br />
              50670 Köln
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section7')}</h2>
            <p className="text-ngbc-dark-text">
              {L('euPlatform')}
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-ngbc-primary hover:text-ngbc-accent ml-1"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              {L('euEmailNote')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section8')}</h2>
            <p className="text-ngbc-dark-text">
              {L('noOdr')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section9')}</h2>
            <p className="text-ngbc-dark-text">
              {L('haftungInhalte')}
            </p>
            <p className="text-ngbc-dark-text mt-4">
              {L('haftungInhalte2')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section10')}</h2>
            <p className="text-ngbc-dark-text">
              {L('haftungLinks')}
            </p>
            <p className="text-ngbc-dark-text mt-4">
              {L('haftungLinks2')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('section11')}</h2>
            <p className="text-ngbc-dark-text">
              {L('urheber')}
            </p>
            <p className="text-ngbc-dark-text mt-4">
              {L('urheber2')}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};
